import { tutorialJourneysClient } from "../api/ApiClients";
import {
  CreateTutorialJourneyCommand,
  ICreateTutorialJourneyCommand,
  IUpdateTutorialJourneyCommand,
  ITutorialDto,
  UpdateTutorialJourneyCommand,
  TutorialJourneyType,
  ITutorialJourneyDto,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class TutorialJourneysService extends ServiceBase {
  async getTutorialJourneys(): Promise<ITutorialJourneyDto[]> {
    return tutorialJourneysClient.getTutorialJourneys();
  }

  async getTutorialJourneyByType(
    type: TutorialJourneyType,
  ): Promise<ITutorialDto> {
    return tutorialJourneysClient.getTutorialJourneyByType(type);
  }

  async createTutorialJourney(data: ICreateTutorialJourneyCommand) {
    const command = CreateTutorialJourneyCommand.fromJS(data);
    return tutorialJourneysClient.createTutorialJourney(command);
  }

  async updateTutorialJourney(data: IUpdateTutorialJourneyCommand) {
    const command = UpdateTutorialJourneyCommand.fromJS(data);
    return tutorialJourneysClient.updateTutorialJourney(command.id, command);
  }

  async deleteTutorialJourney(id: number) {
    return tutorialJourneysClient.deleteTutorialJourney(id);
  }
}

export default new TutorialJourneysService();
